import { render } from "./DialogBookRefundComplete.vue?vue&type=template&id=3c6f9a66"
import script from "./DialogBookRefundComplete.vue?vue&type=script&lang=js"
export * from "./DialogBookRefundComplete.vue?vue&type=script&lang=js"
script.render = render

export default script